import axios, { AxiosResponse } from 'axios';
import {setMembers, setMembersFirst} from 'redux/actionCreators/membersActions';
import { endpoints } from 'api/endpoints';
import middleware from 'api/middleware';
import { LIMIT_ITEM_ON_PAGE } from 'utils/constants';
import proxyAxios from './proxyAxios';
import { apiMap } from './apiMap';
import { MemberResponse } from 'redux/actionTypes/membersState.types';
// TODO: relocate 'FormData' as it is a driect dependency from specific component
import { FormData } from 'sections/Directory/components/Filter/Filter';

let countPages: number = 0;

export const getUserThunk = async () => {
  return await axios.post(apiMap.user);
};

export const getMembersQuantity = async () => {
  return middleware(async () => await proxyAxios.get(endpoints.membersQuantity), {
    errorInfo: 'getMembersQuantity',
  });
};

export const useSurveyRequests = () => {
  const sendSurveyFormData = async (formData: any): Promise<AxiosResponse> => {
    return await axios.post(apiMap.survey.save, formData);
  };

  return {sendSurveyFormData};
};

export const sendConfirmationEmail = async (formData: any) => {
  return await axios.post(apiMap.forgotPassword, formData);
};

export const sendFormDataDemo = async (formData: any) => {
  return await axios.post(apiMap.formDemo, formData);
};

export const sendBenefitsLeadForm = async (formData: any) => {
  return await axios.post(apiMap.leadsForm, formData);
};

export const sendNewUserPassword = async (formData: any) => {
  return await axios.post(apiMap.confirmPassword, formData);
};

export const getMembersFilter = async () => {
  const response = await middleware(() => axios.get(apiMap.directory.filter), {
    errorInfo: '/api/v1/dfa/aggregate-cities',
    Function: 'getMembersFilter()',
    Author: '#Max',
  });
  return response?.data;
};

export const getMembersRequests = async (page: number, filter: FormData): Promise<{ data: MemberResponse }> => {
  const formData = {
    custom: filter.text,
    country: filter.country,
    city: filter.city,
    account_type: filter.status.toUpperCase(),
    carrier_type: filter.service,
    page,
    limit: LIMIT_ITEM_ON_PAGE,
  };
  const response = await middleware(
    () => {
      return axios.post(apiMap.directory.members, formData);
    },
    {errorInfo: '/api/v1/dfa/members', Function: 'getMembers()', Author: '#Max', ...formData}
  );
  return response.data;
};

export const getFaqData = async () => {
  return await axios.get(apiMap.help.faqData);
};

export const useBlacklistRequests = () => {
  const getAllCompaniesRequest = async () => {
    return await axios.get(apiMap.blacklist.getAllCompanies, {headers: {'Content-Type': 'application/json'}});
  };

  const getOneCompanyRequest = async (companyQuery: string) => {
    return await axios.get(apiMap.blacklist.getOneCompany(companyQuery));
  };

  const getAllCountriesRequest = async () => {
    return await axios.get(apiMap.blacklist.getAllCountries, {headers: {'Content-Type': 'application/json'}});
  };

  const getAllManagersRequest = async () => {
    return await axios.get(apiMap.blacklist.getAllManagers, {headers: {'Content-Type': 'application/json'}});
  };

  const getCities = async (countryCode: string) => {
    return await axios.get(apiMap.blacklist.getCities(countryCode));
  };

  const addNewCompany = async (formData: any) => {
    return await axios.post(apiMap.blacklist.addNewCompany, formData);
  };

  const editCompany = async (formData: any) => {
    return await axios.post(apiMap.blacklist.editCompany(), formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    });
  };

  const removeCompany = async (companyId: number) => {
    return await axios.delete(apiMap.blacklist.removeCompany(companyId));
  };

  const removeFile = async (fileId: number) => {
    return await axios.delete(apiMap.blacklist.removeFile(fileId));
  };

  return {
    getAllCompaniesRequest,
    getOneCompanyRequest,
    getAllCountriesRequest,
    getAllManagersRequest,
    getCities,
    addNewCompany,
    editCompany,
    removeCompany,
    removeFile,
  };
};
